"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gradient = exports.MenuBarSeparator = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const react_1 = __importDefault(require("react"));
const MenuBarSeparator = () => {
    return (react_1.default.createElement("div", { style: {
            width: "10px",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            mask: "linear-gradient(#000, #0000)",
        } },
        react_1.default.createElement(exports.Gradient, { style: { width: "9px", opacity: 0.3 } }),
        react_1.default.createElement("div", { style: { width: "1px", background: "white", opacity: 0.08 } })));
};
exports.MenuBarSeparator = MenuBarSeparator;
exports.Gradient = styled_components_1.styled.div `
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
`;
//# sourceMappingURL=MenuBarSeparator.js.map